
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    setLoaded(true);
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: '關於我', path: '/about' },
    { label: '技能', path: '/skills' },
    { label: '經歷', path: '/experience' },
    { label: '個人專案', path: '/side-projects' },
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled || !isHome ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 flex items-center justify-between">
        <Link
          to="/"
          className={`text-2xl font-bold transition-all duration-500 cursor-pointer hover:scale-105 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'} ${scrolled || !isHome ? 'text-gray-900' : 'text-gray-900'}`}
          style={{ fontFamily: 'Playfair Display, serif' }}
        >
          Frances
        </Link>

        {/* Desktop nav links */}
        <div className="hidden md:flex items-center gap-12">
          {navItems.map((item, index) => (
            <Link
              key={item.label}
              to={item.path}
              className={`text-sm font-medium transition-all duration-300 hover:text-orange-600 cursor-pointer relative group ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'} ${scrolled || !isHome ? 'text-gray-700' : 'text-gray-700'}`}
              style={{ transitionDelay: `${(index + 1) * 50}ms` }}
            >
              {item.label}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-orange-500 to-rose-500 group-hover:w-full transition-all duration-300"></span>
            </Link>
          ))}
          <Link
            to="/#contact"
            className={`px-8 py-3 rounded-full text-sm font-semibold bg-gradient-to-r from-orange-500 to-rose-500 text-white hover:shadow-lg hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'}`}
            style={{ transitionDelay: '300ms' }}
          >
            聯絡我
          </Link>
        </div>

        {/* Hamburger button — mobile only */}
        <button
          className="md:hidden flex items-center justify-center w-10 h-10 text-gray-700 focus:outline-none"
          onClick={() => setMenuOpen(prev => !prev)}
          aria-label="Toggle menu"
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
        </button>
      </div>

      {/* Mobile dropdown menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 shadow-lg w-full">
          <div className="flex flex-col px-4 py-4 gap-1">
            {navItems.map((item) => (
              <Link
                key={item.label}
                to={item.path}
                onClick={() => setMenuOpen(false)}
                className="text-sm font-medium text-gray-700 hover:text-orange-600 py-3 border-b border-gray-100 transition-colors duration-200"
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/#contact"
              onClick={() => setMenuOpen(false)}
              className="mt-3 px-8 py-3 rounded-full text-sm font-semibold text-center bg-gradient-to-r from-orange-500 to-rose-500 text-white hover:shadow-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              聯絡我
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
